export class ResponsePojo{
    
responseId:number;
responseText:string;
responseBoolean:boolean;
status:string;
details:string;
}